import {HttpResponse} from "@angular/common/http";
import printJS from "print-js";

export class DownloaderHelper {
  /**
   * So to make pdf file downloaded and not opened in tab
   * @param response
   */
  public static processDownloadedResponse(response: HttpResponse<Blob>, print: boolean = false, dialog: any = null): boolean {
    const newBlob = new Blob([response.body], {type: "application/pdf"});
    const header = response.headers.get('Content-Disposition');
    if (!header) {
      throw new Error('No Content-Disposition header! Can\'t process request');
    }
    if (!print) {
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement("a");
      link.href = data;
      link.download = header.split(';')[1].split('filename')[1].split('=')[1].trim().replace(/"/g, '');
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        link.remove();
      }, 100);
    } else {
      printJS({
        printable: URL.createObjectURL(newBlob),
        type:'pdf',
        onLoadingEnd: () => {
          dialog.closeAll()
        }
      });
    }

    return true;
  }

  public static processMailToLink(linkText: string) {
    const link = document.createElement("a");
    link.href = linkText;

    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window
      })
    );

  }
}
